import React from 'react';

import { ArrowDropDown } from '@mui/icons-material';
import { Menu, MenuItem, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';

import { ActionsTableCell, StyledActionButton, StyledTableCell } from './index.styles';
import { useMenuAnchor } from '../hooks/useMenuAnchor';
import { TemplateRecord } from '../types';

interface DraftTemplateRowInterface {
    template: TemplateRecord;
    openDeleteModal: (template: TemplateRecord) => void;
    openPublishModal: (templateId: number) => void;
}

const DraftTemplateRow: React.FC<DraftTemplateRowInterface> = ({ template, openDeleteModal, openPublishModal }) => {
    const { t } = useTranslation('templates');
    const { open, anchorEl, handleOpen, handleClose } = useMenuAnchor();
    const history = useHistory();
    const { search } = useLocation();

    const onMenuDelete = () => {
        handleClose();
        openDeleteModal(template);
    };

    const openEditTemplate = () => {
        history.push(`/template-manager/edit/${template.sid}${search}`);
    };

    return (
        <TableRow>
            <StyledTableCell>{template.class_name}</StyledTableCell>
            <ActionsTableCell>
                <StyledActionButton variant="outlined" onClick={openEditTemplate}>
                    {t('edit')}
                </StyledActionButton>
                <StyledActionButton variant="outlined" onClick={() => openPublishModal(template.sid)}>
                    {t('publish')}
                </StyledActionButton>
                <StyledActionButton
                    variant="outlined"
                    endIcon={<ArrowDropDown />}
                    id={`more_button_${template.sid}`}
                    aria-controls={open ? `more_menu_${template.sid}` : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleOpen}
                >
                    {t('more')}
                </StyledActionButton>
                <Menu
                    id={`more_menu_${template.sid}`}
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                        'aria-labelledby': `more_button_${template.sid}`
                    }}
                >
                    <MenuItem onClick={onMenuDelete}>{t('delete')}</MenuItem>
                </Menu>
            </ActionsTableCell>
        </TableRow>
    );
};

export default DraftTemplateRow;
